/**
 * @description Masks for input fields
 *
 * "X" is a placeholder character - any other characters or symbols will be added to the input field
 */

export const INPUT_MASK = {
  IBAN: 'XXXX XXXX XXXX XXXX XXXX XX',
  PD_MEASUREMENT: 'XX.XX mm',
} as const

export const MASK_RESERVER_CHAR = 'X'
